import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "./utils";
import {responses} from "./responses";
import {errorHandler} from "./errorHandler";
import {authentication} from "@/Services/auth";
import queryStringify from "qs-stringify";


// PRODUCTION
window.synergyApi = 'https://lna.pos.co.zm/SynergyApi/'
window.ticketApi2 = `https://lna.pos.co.zm/PettyCashApi/api/v1/`
window.ticketApi = `https://lna.pos.co.zm/TicketApp/`

// LOCAL DEV
// window.synergyApi = 'http://localhost:8282/SynergyApi/'
// window.ticketApi2 = `http://localhost:7098/PettyCashApi/api/v1/`;
// window.ticketApi = `http://localhost:7097/TicketApp/`;

window.backOfficeApi = `https://overflow.pos.co.zm/Lyt-SoftBackOfficeApi/`;
// window.backOfficeApi = `https://realtime.pos.co.zm:8443/Lyt-SoftBackOfficeApi/`;

// PRODUCTION
window.paymentApi = `https://overflow.pos.co.zm/Franchise_OnlineServer/employeePaymentRequest/`

// LOCAL DEV
// window.paymentApi = `http://192.168.30.11:8080/Franchise_OnlineServer/employeePaymentRequest/`



window.responses = responses;
window.errorHandler = errorHandler
window.authenticator = authentication;

const EventBus = new Vue()
window.EventBus = EventBus

window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

Vue.prototype.$utils = utils;
window.$utils = utils;
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);
window.openUrl = (url, target = '_blank') => window.open(url, target);

// ============================================================
// Usage Tracking - Copy this to other apps
// ============================================================
window.usageTracker = {
    // Get or generate device ID (persists in localStorage)
    getDeviceId() {
        let deviceId = localStorage.getItem('chrilan_device_id');
        if (!deviceId) {
            deviceId = 'dev_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
            localStorage.setItem('chrilan_device_id', deviceId);
        }
        return deviceId;
    },
    // Track usage - call this to record an event
    track(appName, options = {}) {
        // Map friendly app names to app_keys
        const appKeyMap = {
            'Petty Cash': 'petty-cash',
            'Help Desk': 'help-desk',
            'Synergy Dealer Platform': 'synergy-dealer',
        };
        const app_key = appKeyMap[appName] || appName;

        const payload = {
            app_key: app_key,
            user_id: options.userId || window.userId || null,
            device_id: this.getDeviceId(),
            feature: options.feature || null,
            action: options.action || 'view',
        };
        fetch(`${window.synergyApi}api/v1/usage/record`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).catch(err => console.warn('Usage tracking failed:', err));
    }
};
